<template>
  <div v-if="resourcesFetching">
    <p class="text-muted gb-text-1"><i class="fa fa-circle-o-notch fa-spin"/> Loading Resources...</p>
  </div>
  <div :class="['resource-container', { 'resource-container-indentation': isIndented }]" v-else>
    <template v-if="resources.length > 0">
      <MultilingualResourcePreviewCards
        v-if="hasNonEnglishLang"
        :show-resource-tile="showResourceTile"
        :resources="filteredResources"
        :evt-data="evtData"
        :object-id="objectId" />
      <template v-else-if="showResourceTile">
        <ResourceTile
          v-for="resource in sortedResources"
          :key="resource.uuid"
          v-bind="resource"
          :evt-data="evtData"/>
      </template>
      <template v-else>
        <ResourcePreviewCard
          v-for="resource in sortedResources"
          :key="resource.uuid"
          v-bind="resource"/>
      </template>
    </template>
  </div>
</template>

<script>
import ResourcePreviewCard from '@/components/ResourcePreviewCard'
import ResourceTile from './goals/ResourceTile'
import MultilingualResourcePreviewCards from '@/components/MultilingualResourcePreviewCards'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ResourceListContainer',
  components: {
    ResourcePreviewCard,
    ResourceTile,
    MultilingualResourcePreviewCards
  },
  props: {
    uuids: {
      type: Array,
      required: true
    },
    showResourceTile: {
      type: Boolean,
      required: true
    },
    isIndented: {
      type: Boolean,
      required: false,
      default: false
    },
    evtData: {
      type: Object,
      default: () => {}
    },
    objectId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('goaldetail', [
      'resourcesById',
      'resourcesFetchingById',
      'hasNonEnglishLangById',
      'filteredResourcesById'
    ]),
    resources() {
      return this.resourcesById(this.objectId) || []
    },
    resourcesFetching() {
      return this.resourcesFetchingById(this.objectId) || false
    },
    hasNonEnglishLang() {
      return this.hasNonEnglishLangById(this.objectId) || false
    },
    filteredResources() {
      return this.filteredResourcesById(this.objectId) || []
    },
    sortedResources() {
      const resources = this.filteredResources

      const withSetNumber = resources.filter(r => r.set_number && r.set_number > 0)
      const withoutSetNumber = resources.filter(r => !r.set_number || r.set_number === 0)


      withSetNumber.sort((a, b) => a.set_number - b.set_number)


      return [...withSetNumber, ...withoutSetNumber]
    }
  }
}
</script>

<style lang="less" scoped>
.resource-container-indentation {
  display: flex;
  margin-left: 32px;
}

.resource-container {
  display: flex;
  flex-wrap: wrap;
  font-size: 14px;
}
</style>
